export default function () {
  return (<hr />);
}
